/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import { useSearchParams } from 'react-router-dom';
import { initialPaginateConfig, getPureParams } from '../utils/helpers';

const fetchQueries = (searchParams, filterQuery = [], search_type = null) => {
	let params = {};

	searchParams.forEach((value, key) => {
		const filterFn = filterQuery?.filter((x) => x.query === key) || [];

		if (value !== 'undefined' && value !== 'null' && value !== '' && !isEmpty(value)) {
			if (filterFn.length > 0) {
				params = {
					...params,
					[key]: filterFn[0].transformFn(value),
				};
			} else {
				params = {
					...params,
					[key]: value,
				};
			}
		}
	});

	/**
	 * If you need any default value while loading the page,
	 * assign some values in filterQuery.value
	 */
	const defaultValue = filterQuery.reduce((acc, curr) => {
		if (!acc[curr?.query] && curr?.value) {
			acc[curr?.query] = curr?.value;
		}
		return acc;
	}, {});

	return { ...initialPaginateConfig, ...defaultValue, ...params, search_type };
};

const readPersisted = (persistKey) => {
	if (!persistKey) return null;
	try {
		const stored = window.sessionStorage.getItem(persistKey);
		return stored ? JSON.parse(stored) : null;
	} catch (error) {
		return null;
	}
};

/**
 *  props.filterQuery is for transforming query params into your desired data type
 */
export default function useVendoruery({ filterQuery = [], search_type = null, persistKey = null }) {
	const [searchParams, setSearchParams] = useSearchParams();
	const [paginateConfig, setpaginateConfig] = useState(() => {
		const fromUrl = fetchQueries(searchParams, filterQuery, search_type);
		if (persistKey && [...searchParams.keys()].length === 0) {
			const persisted = readPersisted(persistKey);
			if (persisted) return { ...fromUrl, ...persisted, search_type };
		}
		return fromUrl;
	});

	useEffect(() => {
		// Here we are adding the params in the URL while the paginateConfig changes

		/**
		 * To Remove not proper data from payload, will remove undefined, null, empty string
		 */
		const temp = getPureParams(paginateConfig);
		const { sort, ...rest } = temp;

		const newSearchParams = new URLSearchParams({ ...sort, ...rest });
		setSearchParams(newSearchParams);

		if (persistKey) {
			try {
				window.sessionStorage.setItem(persistKey, JSON.stringify(temp));
			} catch (error) {
				// best-effort persistence
			}
		}
	}, [paginateConfig]);

	return [paginateConfig, setpaginateConfig];
}
